module.exports = __webpack_public_path__ + "static/media/light_orange-theme.b5a56768.png";